import { render, staticRenderFns } from "./ReportRequirementDetail.vue?vue&type=template&id=3884786e&scoped=true&"
import script from "./ReportRequirementDetail.vue?vue&type=script&lang=js&"
export * from "./ReportRequirementDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReportRequirementDetail.vue?vue&type=style&index=0&id=3884786e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3884786e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
